import licenseIdMethods from './Licenses.id'

export const ManageLicenseServices = {
  id: {
    ...licenseIdMethods
  }
}

export * from './Licenses.types'
